export class RechargeFilter {
  text: string;
  startDate: string;
  endDate: string;
  order: string;
  orderDirection: boolean;
  author: string;
}
